var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_c('app-prices'),_vm._v(" "),_c('app-discounts'),_vm._v(" "),_c('app-tags'),_vm._v(" "),_c('app-attributes')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@2.7.16_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.2_mtgpqfwjwwc4gzzdhxqqjlkm5m/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fb9b5ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@2.7.16_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.2_mtgpqfwjwwc4gzzdhxqqjlkm5m/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Filters.vue
// module id = 403
// module chunks = 0